export const signUpAction = '[actions] signup user'
export const LOGIN_ACTION = '[actions]  Student Login'
export const AUTH_ACTION = '[ACTION] USER AUTHENTICATION'
export const AUTO_LOGIN_ACTION = '[ACTION] USER AUTO LOGIN'
export const LOGOUT_ACTION = '[ACTION] LOGOUT USER'

export const SET_USER_TOKEN_MUTATION = '[actions] set user token'
export const TESTING_ACTION = '[ACTION] TESTING'
export const SHOW_LOADING_MUTATION = '[MUTATION] SHOW LOADING SPINNER'
export const GET_NAV_ITEM = '[GETTERS] NAV ITEM'

export const GET_USER_IMAGE = '[GETTERS] STUDENT IMAGE'
export const GET_USER_TOKEN = '[GETTERS] STUDENT TOKEN'
export const GET_USER_NAME = '[GETTER] STUDENT NAME'
export const IS_USER_AUTHENTICATE_GETTER = '[GETTERS] USER AUTHENTICATE'


export const APPLICANT_LOGIN_ACTION = '[APPLICANT ACTION] Applicant Login'
export const APPLICANT_REGISTRATION_ACTION = '[ACTION] Applicant Registration'
export const GET_USER_TYPE = '[GETTER] USER TYPE'
